import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHero } from '@/components/ui-bits';
import { Reveal } from '@/components/motion';
import { OrnamentHeart } from '@/components/Ornaments';
import { api } from '@/lib/api';

export default function Stories() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get(`/stories?lang=${lang}`).then((r) => setStories(r.data)).catch(() => {});
  }, [lang]);

  return (
    <div data-testid="stories-page">
      <PageHero
        eyebrow={t('nav.stories')}
        title={t('stories.title')}
        subtitle={t('stories.subtitle')}
        ornament={<OrnamentHeart className="hidden md:block absolute right-16 top-20 w-32 text-terracotta/25" />}
      />

      <section className="px-5 md:px-10 pb-24">
        <div className="max-w-[1180px] mx-auto flex flex-col gap-10 md:gap-16">
          {stories.map((s, i) => (
            <Reveal key={s.story_id} delay={i * 0.06}>
              <figure
                data-testid={`story-${i}`}
                className={`grid md:grid-cols-2 gap-8 md:gap-12 items-center ${i % 2 === 1 ? 'md:[direction:rtl]' : ''}`}
              >
                <div className={`rounded-[2rem] overflow-hidden border-[10px] border-rosa ${i % 2 === 0 ? 'rotate-[1.5deg]' : 'rotate-[-1.5deg]'} [direction:ltr]`}>
                  <img src={s.image} alt="" className="w-full h-[300px] md:h-[400px] object-cover" />
                </div>
                <figcaption className="[direction:ltr]">
                  <span className="text-terracotta text-6xl font-serif leading-none">“</span>
                  <p className="font-serif text-2xl md:text-4xl leading-[1.25] text-textDark/90 -mt-4">{s.quote}</p>
                  <div className="mt-7">
                    <p className="font-semibold text-xl text-textDark">{s.name}</p>
                    <p className="text-salvia font-medium">{s.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
